export default __webpack_public_path__ + "rupee-indian.png";